@if (!showCopyClipboard) {
  <div
    class="info-block"
    [ngClass]="bgClass">
    <div class="row align-items-center g-3">
      <div class="col">
        <div class="small text-muted vertical-align-middle">
          <span class="v-align-middle">{{ label }}</span>
          &nbsp;
          @if (tooltipText && tooltipDisplay) {
            <i
              class="v-align-middle"
              [ngbTooltip]="tooltipText"
              [ngClass]="tooltipIcon + ' ' + tooltipClass">
            </i>
          }
        </div>
        @if (!showPlaceholder()) {
          <div class="fw-semibold v-align-middle">
            @if (showLineBreaks) {
              <pre class="normalize-pre">
                {{ value | emptyIndicator }}
              </pre>
            }
            @if (!showLineBreaks) {
              {{ value | emptyIndicator }}
            }
          </div>
        }
        @if (showPlaceholder()) {
          <div class="text-muted">
            <em>{{ placeholder }}</em>
          </div>
        }
      </div>
      @if (showButton) {
        <div class="col-auto">
          <ng-content select="[button]"></ng-content>
        </div>
      }
    </div>
  </div>
}

@if (showCopyClipboard) {
  <button
    class="copy-clipboard"
    (click)="copyTextToClipboard(copyRef.innerText)"
    aria-label="Copy to clipboard">
    <div class="info-block">
      <div class="small text-muted">{{ label }}</div>
      <div #copyRef>{{ value | emptyIndicator }} <i class="iconoir-copy"></i></div>
    </div>
  </button>
}
